import React, { useEffect, useState } from 'react';

function CartPage() {
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      if (window.WOW) {
        try {
          new window.WOW().init();
        } catch (e) {
          console.log('WOW.js not available');
        }
      }
    }, 500);

    // Load cart from localStorage
    loadCart();
  }, []);

  const loadCart = () => {
    try {
      const savedCart = JSON.parse(localStorage.getItem('cart') || '[]');
      setCartItems(savedCart);
      setLoading(false);
    } catch (error) {
      console.error('Error loading cart:', error);
      setLoading(false);
    }
  };

  const updateQuantity = (id, newQuantity) => {
    if (newQuantity > 0) {
      const updatedCart = cartItems.map(item =>
        item.id === id ? { ...item, quantity: newQuantity } : item
      );
      setCartItems(updatedCart);
      localStorage.setItem('cart', JSON.stringify(updatedCart));
    }
  };

  const removeItem = (id) => {
    const updatedCart = cartItems.filter(item => item.id !== id);
    setCartItems(updatedCart);
    localStorage.setItem('cart', JSON.stringify(updatedCart));
  };

  const clearCart = () => {
    setCartItems([]);
    localStorage.setItem('cart', JSON.stringify([]));
  };

  const subtotal = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const tax = subtotal * 0.1;
  const total = subtotal + tax;

  const handleCheckout = () => {
    // Store cart items in localStorage for checkout page
    localStorage.setItem('checkoutItems', JSON.stringify(cartItems));
    localStorage.setItem('checkoutTotal', JSON.stringify({
      subtotal,
      tax,
      total
    }));
    window.location.href = '/checkout';
  };

  return (
    <>
      {/* Page Header Start */}
      <section className="page-header">
        <div className="page-header__bg" style={{ backgroundImage: 'url(/assets/images/backgrounds/slider-4-1.jpg)' }}></div>
        <div className="container">
          <div className="page-header__inner">
            <h2 className="page-header__title">Shopping Cart</h2>
            <ul className="thm-breadcrumb">
              <li><a href="/">Home</a></li>
              <li><span>/</span></li>
              <li><span>Cart</span></li>
            </ul>
          </div>
        </div>
      </section>
      {/* Page Header End */}

      {/* Cart Section Start */}
      <section className="cart-section" style={{ padding: '80px 0', backgroundColor: '#f9f9f9' }}>
        <div className="container">
          {loading ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <p>Loading cart...</p>
            </div>
          ) : cartItems.length > 0 ? (
            <div className="row" style={{ gap: '20px' }}>
              <div className="col-lg-8">
                <div style={{
                  backgroundColor: '#fff',
                  borderRadius: '10px',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
                  overflow: 'hidden'
                }}>
                  <table className="cart-table" style={{
                    width: '100%',
                    borderCollapse: 'collapse'
                  }}>
                    <thead>
                      <tr style={{ backgroundColor: '#f9f9f9', borderBottom: '2px solid #eee' }}>
                        <th style={{ padding: '15px', textAlign: 'left' }}>Product</th>
                        <th style={{ padding: '15px', textAlign: 'center' }}>Price</th>
                        <th style={{ padding: '15px', textAlign: 'center' }}>Quantity</th>
                        <th style={{ padding: '15px', textAlign: 'center' }}>Total</th>
                        <th style={{ padding: '15px', textAlign: 'center' }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartItems.map((item) => (
                        <tr key={item.id} style={{ borderBottom: '1px solid #eee' }}>
                          <td style={{ padding: '15px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                              <img src={item.image} alt={item.name} style={{
                                width: '60px',
                                height: '60px',
                                objectFit: 'cover',
                                borderRadius: '5px'
                              }} />
                              <div>
                                <h4 style={{ margin: 0, marginBottom: '5px' }}>{item.name}</h4>
                                <p style={{ margin: 0, fontSize: '12px', color: '#999' }}>
                                  {item.category || 'Product'}
                                </p>
                              </div>
                            </div>
                          </td>
                          <td style={{ padding: '15px', textAlign: 'center' }}>
                            ${item.price.toFixed(2)}
                          </td>
                          <td style={{ padding: '15px', textAlign: 'center' }}>
                            <input
                              type="number"
                              min="1"
                              value={item.quantity}
                              onChange={(e) => updateQuantity(item.id, parseInt(e.target.value))}
                              className="quantity-input"
                              style={{
                                width: '60px',
                                padding: '8px',
                                border: '1px solid #ddd',
                                borderRadius: '5px',
                                textAlign: 'center',
                                fontFamily: 'inherit'
                              }}
                            />
                          </td>
                          <td style={{ padding: '15px', textAlign: 'center', fontWeight: '600' }}>
                            ${(item.price * item.quantity).toFixed(2)}
                          </td>
                          <td style={{ padding: '15px', textAlign: 'center' }}>
                            <button
                              onClick={() => removeItem(item.id)}
                              className="remove-btn"
                              style={{
                                backgroundColor: '#ff6b6b',
                                color: '#fff',
                                border: 'none',
                                padding: '8px 12px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                transition: 'all 0.3s'
                              }}
                              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#d63031'}
                              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#ff6b6b'}
                            >
                              🗑️ Remove
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div style={{ padding: '15px', backgroundColor: '#f9f9f9', textAlign: 'right' }}>
                    <button
                      onClick={clearCart}
                      style={{
                        backgroundColor: '#999',
                        color: '#fff',
                        border: 'none',
                        padding: '10px 20px',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontSize: '14px'
                      }}
                    >
                      Clear Cart
                    </button>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="cart-summary" style={{
                  backgroundColor: '#fff',
                  padding: '30px',
                  borderRadius: '10px',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
                  position: 'sticky',
                  top: '20px'
                }}>
                  <h3 style={{ marginBottom: '25px', fontSize: '20px' }}>Order Summary</h3>
                  <div className="summary-row" style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '15px',
                    paddingBottom: '15px',
                    borderBottom: '1px solid #eee'
                  }}>
                    <span>Subtotal:</span>
                    <span>${subtotal.toFixed(2)}</span>
                  </div>
                  <div className="summary-row" style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '15px',
                    paddingBottom: '15px',
                    borderBottom: '1px solid #eee'
                  }}>
                    <span>Tax (10%):</span>
                    <span>${tax.toFixed(2)}</span>
                  </div>
                  <div className="summary-row total" style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '25px',
                    paddingBottom: '15px',
                    borderBottom: '2px solid #eee',
                    fontSize: '18px',
                    fontWeight: '700'
                  }}>
                    <span>Total:</span>
                    <span>${total.toFixed(2)}</span>
                  </div>
                  <button
                    onClick={handleCheckout}
                    className="thm-btn proceed-btn"
                    style={{
                      width: '100%',
                      padding: '12px',
                      marginBottom: '10px',
                      backgroundColor: '#007bff',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer',
                      fontWeight: '600',
                      transition: 'all 0.3s'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#0056b3'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#007bff'}
                  >
                    Proceed to Checkout
                  </button>
                  <a href="/products" className="thm-btn continue-shopping-btn" style={{
                    display: 'block',
                    width: '100%',
                    padding: '12px',
                    backgroundColor: '#f0f0f0',
                    color: '#333',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    textAlign: 'center',
                    fontWeight: '600',
                    textDecoration: 'none',
                    transition: 'all 0.3s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e0e0e0'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}>
                    Continue Shopping
                  </a>
                </div>
              </div>
            </div>
          ) : (
            <div className="empty-cart" style={{
              textAlign: 'center',
              padding: '80px 20px',
              backgroundColor: '#fff',
              borderRadius: '10px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
            }}>
              <div style={{ fontSize: '60px', marginBottom: '20px' }}>🛒</div>
              <h2 style={{ marginBottom: '15px' }}>Your Cart is Empty</h2>
              <p style={{ marginBottom: '30px', color: '#666' }}>
                Discover our products and resources to support your wellness journey.
              </p>
              <a href="/products" className="thm-btn" style={{
                display: 'inline-block',
                padding: '12px 30px',
                backgroundColor: '#007bff',
                color: '#fff',
                textDecoration: 'none',
                borderRadius: '5px',
                cursor: 'pointer'
              }}>
                Continue Shopping
              </a>
            </div>
          )}
        </div>
      </section>
      {/* Cart Section End */}
    </>
  );
}

export default CartPage;
